module.exports = __webpack_public_path__ + "static/img/time-line-gold.84f0f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/time-line-gold.png
// module id = 1236
// module chunks = 4